import React, { useEffect, useState, useCallback } from 'react';
import { Server } from 'lucide-react';
import api from '../services/api.js';
import ServerPaymentsModal from './ServerPaymentsModal.jsx';

const POLL_INTERVAL_MS = 5 * 60_000;

const ServerPaymentsChip = () => {
  const [minDaysLeft, setMinDaysLeft] = useState(null);
  const [open, setOpen] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get('/server-payments');
      const groups = data?.data || {};
      const allDays = Object.values(groups)
        .flat()
        .map((r) => r.days_left)
        .filter((d) => d != null);
      setMinDaysLeft(allDays.length ? Math.min(...allDays) : null);
    } catch {
      setMinDaysLeft(null);
    }
  }, []);

  useEffect(() => {
    refresh();
    const id = setInterval(refresh, POLL_INTERVAL_MS);
    return () => clearInterval(id);
  }, [refresh]);

  const handleClose = useCallback(() => {
    setOpen(false);
    refresh();
  }, [refresh]);

  // Цвет чипа по самому «горящему» серверу.
  const tone =
    minDaysLeft == null
      ? 'bg-gray-50 dark:bg-gray-700/40 text-gray-600 dark:text-gray-300 border-gray-200/60 dark:border-gray-600/40'
      : minDaysLeft <= 0
        ? 'bg-red-50 dark:bg-red-900/20 text-red-700 dark:text-red-300 border-red-200/60 dark:border-red-700/40'
        : minDaysLeft <= 5
          ? 'bg-amber-50 dark:bg-amber-900/20 text-amber-700 dark:text-amber-300 border-amber-200/60 dark:border-amber-700/40'
          : 'bg-emerald-50 dark:bg-emerald-900/20 text-emerald-700 dark:text-emerald-300 border-emerald-200/60 dark:border-emerald-700/40';

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        title="Оплата серверов"
        className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg transition-colors border ${tone}`}
      >
        <Server size={16} />
        {minDaysLeft != null && (
          <span className="text-sm font-medium tabular-nums">
            {minDaysLeft < 0 ? `−${Math.abs(minDaysLeft)}` : minDaysLeft} дн.
          </span>
        )}
      </button>
      <ServerPaymentsModal open={open} onClose={handleClose} />
    </>
  );
};

export default ServerPaymentsChip;
